<template>
  <div class="control-div">
    <div class="center-group" v-if="small">
      <div class="button-group">
        <email-and-call :artist="artist" :center="small" />
      </div>
    </div>
    <div class="button-group" :class="{bgcenter: small}" >
      <div class="button-group">
        
        <ix-router-link class="button-link" :class="{large: large}" v-if="artist.illustrator" 
          :to="'/artists/' + artist.portfolio_url">{{ $nippets.portfolio.illustration }}</ix-router-link>
        <ix-router-link class="button-link" :class="{large: large}" v-if="artist.animation" 
          :to="'/animators/' + artist.portfolio_url">{{ $nippets.portfolio.animation }}</ix-router-link>
      </div>
      <div class="button-group">
        <ix-router-link class="button-link" :class="{large: large}" :to="'/artists/' + artist.portfolio_url + '/news'">{{ $nippets.portfolio.news }}</ix-router-link>
        <ix-router-link class="button-link" v-if="details.has_live_video" :class="{large: large}" :to="'/artists/' + artist.portfolio_url + '/videos'">{{ $nippets.portfolio.videos }}</ix-router-link>
        <a v-if="!animatorOnly" :href="pdfDownloadLink" class="button-link" :class="{large: large}" target="_blank" rel="noopener" v-on:click="handlePdfClick">{{ $nippets.portfolio.pdf }}</a>
      </div>
    </div>
    <div class="flex-group" v-if="large">
      <div class="button-group" v-html="getPleaseCall()"></div>
      <div class="button-group" v-if="(this.$store.state.lang === 'US') && speakpipe">
        <speakpipe-widget large />
      </div>
      <div class="button-group">
        <small-button :large="!small" v-on:click="showQuote">
          {{ $nippets.contact }}
          <info-bubble><span v-html="$nippets.portfolio.bubble"></span></info-bubble>
        </small-button>
      </div>
    </div>
  </div>
</template>

<script>
import EmailAndCall from '@/components/panels/EmailAndCall.vue'
import InfoBubble from '../../components/widgets/InfoBubble.vue'
//const avails = ['CN','FR','US','BR','SX','IN','SG']

export default {

  props: {
    artist: Object,
    details: Object,
    mobile: Boolean,
    small: Boolean,
    speakpipe: Boolean
  },
  computed: {
    large () {
      return (!this.mobile) && (!this.small)
    },
    animatorOnly () {
      if(!this.artist) return false
      if((this.artist.animation) && (!this.artist.illustrator)) return true
      return false
    },
    pdfDownloadLink () {
      if(this.artist && this.artist.name) {
        let name = this.artist.formatted_name
        let pdfname = name.replace(/ /g, '_');
        pdfname = pdfname.replace(/'/g, '');
        if(this.$store.state.lang !== 'UK') {
          pdfname += '_' + this.$store.state.lang
        }
        pdfname += '.pdf'
        return this.$k.imagebase + 'media/pdf/' + pdfname
      }
      return ''
    }
  },
  components: {
    EmailAndCall,
    'speakpipe-widget': () => import('@/components/widgets/SpeakWidget.vue'),
    InfoBubble
  },
  methods: {
    handlePdfClick () {
      this.$k.sendGaEvent('ArtistPortfolio', 'PDFClick', this.artist.formatted_name)
    },
    getPleaseCall() {
      return this.$nippets.replace('portfolio.pleaseCall', 'artist', this.artist.formatted_name)
    },
    showQuote () {
      this.$store.commit('setShowQuote', { show: true, artist: this.artist })
      this.$k.sendGaEvent('ArtistPortfolio', 'EmailClick', this.artist.formatted_name)
    }
  }
}
</script>

<style scoped>
.control-div{
    margin-bottom:20px;
    display:flex;
    justify-content: space-between;
    width:100%;
  }

  .button-group{
    margin:0 10px;
    display:inline;
  }

  .control-div .flex-group{
    display:inline-flex;
    align-items:center;
    justify-content: flex-end;
  }

  .center-group{
    display:flex;
    align-items:center;
    align-content: center;
  }

  .button-group:first-child{
    margin-left:0;
  }

  .button-group:last-child{
    margin-right:0;
  }

  @media screen and (max-width:640px){
    .button-group{
      display:block;
      margin:5px 0;
      width:100%;
    }

    .button-group.bgcenter{
      text-align: center;
    }

    .bgcenter .button-group{
      display:inline;
    }

    .button-link{
      margin-bottom:5px;
      color:#444;
      background-color:transparent;
    }

    a.button-link.router-link-exact-active{
      color:#ce0e2d;
      background-color:transparent;
    }

    .control-div{
      display:block;
    }

    .router-link-active{
      display:inline-block;
      padding-right:10px;
    }
  }
</style>